import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';

const BannerDisplay = ({ position }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${API}/banners?position=${position}`);
        setBanners(response.data);
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };
    fetchBanners();
  }, [position]);

  if (banners.length === 0) return null;

  // Top banner - sopra la navbar come Travera
  if (position === 'top') {
    return (
      <div className="bg-white py-2">
        <div className="flex justify-center">
          <div className="relative">
            <span className="absolute -top-1 left-0 text-xs text-[#0a1628] font-medium animate-blink">Annuncio</span>
            {banners.map((banner) => (
              <a 
                key={banner.banner_id} 
                href={banner.link_url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block mt-4"
                data-testid={`top-banner-${banner.banner_id}`}
              >
                <img 
                  src={banner.image_url} 
                  alt={banner.title}
                  className="max-h-[120px] md:max-h-[200px] w-auto object-contain"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="my-6">
      {banners.map((banner) => (
        <a 
          key={banner.banner_id} 
          href={banner.link_url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="block"
        >
          <img 
            src={banner.image_url} 
            alt={banner.title}
            className={position === 'header' ? 'w-full h-auto max-h-60 object-cover' : 'w-full h-auto'}
          />
        </a>
      ))}
    </div>
  );
};

export default BannerDisplay;
